import { useMediaPlayer } from "@vidstack/react";
import { useEffect } from "react";
import { listSubtitleTracksForVideo } from "@/lib/SubtitleTrack";
import { parseFirebaseDate } from "@/firebase/firestoreUtil";
export function TextTracks({
  videoId = '',
  languageOrder
}: {
  videoId: string;
  languageOrder?: string[];
}) {
  const player = useMediaPlayer();
  useEffect(() => {
    console.log('Fetching text tracks');
    listSubtitleTracksForVideo(videoId, languageOrder).then(tracks => {
      // Find default text track based on the dateCreated
      tracks.sort((a, b) => {
        const dateA = parseFirebaseDate(a.dateCreated);
        const dateB = parseFirebaseDate(b.dateCreated);
        return (dateA ? new Date(dateA).getTime() : 0) - (dateB ? new Date(dateB).getTime() : 0);
      });
      const defaultTrack = tracks[0];

      // Recreate the player text tracks based on the new order
      if (player?.textTracks) {
        player.textTracks.clear();
        for (let i = 0; i < tracks.length; i++) {
          player.textTracks.add({
            src: tracks[i].url || 'url',
            kind: 'subtitles',
            label: tracks[i].label || 'label',
            language: tracks[i].languageCode || 'languageCode',
            type: 'vtt'
          });
        }
      }
    });
  }, [videoId, languageOrder]);
  return null;
}